import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 验证规则
export function getCheckRuleByUuid(uuid) {
  return request({
    url: URL.sys.checkRuleDetail,
    method: 'get',
    params: { uuid }
  })
}

export function getCheckRuleList(params) {
  return request({
    url: URL.sys.checkRule,
    method: 'get',
    params
  })
}

export function saveCheckRule(data, uuid) {
  return request({
    url: URL.sys.checkRule,
    method: uuid ? 'put' : 'post',
    data
  })
}

export function beforeSaveValid(data) {
  return request({
    url: URL.sys.beforeSaveValid,
    method: 'post',
    data
  })
}

export function saveCheckRuleFunc(data) {
  return request({
    url: URL.sys.saveRuleUrl,
    method: 'post',
    data
  })
}

export function delCheckRule(uuid) {
  return request({
    url: URL.sys.checkRule,
    method: 'delete',
    params: { uuid }
  })
}

// 验证表达式
export function getCheckExpressionByUuid(uuid) {
  return request({
    url: URL.sys.checkExpressionDetail,
    method: 'get',
    params: { uuid }
  })
}

export function getCheckExpressionList(params) {
  return request({
    url: URL.sys.checkExpression,
    method: 'get',
    params
  })
}

export function saveCheckExpression(data, uuid) {
  return request({
    url: URL.sys.checkExpression,
    method: uuid ? 'put' : 'post',
    data
  })
}

export function delCheckExpression(uuid) {
  return request({
    url: URL.sys.checkExpression,
    method: 'delete',
    params: { uuid }
  })
}

// 验证条件
export function getCheckCriteriaByUuid(uuid) {
  return request({
    url: URL.sys.checkCriteriaDetail,
    method: 'get',
    params: { uuid }
  })
}

// 验证节点在job下是否有配置验证规则
export function hasConfigCheckRule(params) {
  return request({
    url: URL.sys.hasConfigCheckRule,
    method: 'get',
    params
  })
}

// 验证节点在多个job下是否有配置验证规则
export function hasConfigCheckRuleByJobs(data) {
  return request({
    url: URL.sys.hasConfigCheckRuleByJobs,
    method: 'post',
    data
  })
}

export function getCheckCriteriaList(params) {
  return request({
    url: URL.sys.checkCriteria,
    method: 'get',
    params
  })
}

export function saveCheckCriteria(data, uuid) {
  return request({
    url: URL.sys.checkCriteria,
    method: uuid ? 'put' : 'post',
    data
  })
}

// 根据验证节点 查询验证规则
export function queryByNode(params) {
  return request({
    url: URL.sys.queryByNode,
    method: 'get',
    params
  })
}

export function delCheckCriteria(uuid) {
  return request({
    url: URL.sys.checkCriteria,
    method: 'delete',
    params: { uuid }
  })
}

/**
 * 验证任何类型内容
 */
export function checkAnyContent(checkContent, checkNode) {
  return request({
    url: URL.sys.checkAnyContentByNode,
    method: 'post',
    data: checkContent,
    params: { checkNode }
  })
}

// 验证操作分公司是否配置了验证规则
export function hasCheckRuleCondition(data) {
  return request({
    url: URL.sys.hasCheckRuleCondition,
    method: 'post',
    data: data
  })
}

/**
 * 验证发送目的港代理邮件
 */
export function checkSendDestinationPortAgent(data) {
  return request({
    url: URL.sys.checkSendDestinationPortAgent,
    method: 'post',
    data
  })
}

/**
 * 批量 验证发送目的港代理邮件（常规业务，不区分主小票）
 */
export function checkSendDestinationPortAgentMulti(data) {
  return request({
    url: URL.sys.checkSendDestinationPortAgentMulti,
    method: 'post',
    data
  })
}

// 获取验证规则设置
export function getCheckRuleSetting() {
  return request({
    url: URL.sys.getCheckRuleSetting,
    method: 'get'
  })
}

// 保存验证规则设置
export function saveCheckRuleSetting(data) {
  return request({
    url: URL.sys.saveCheckRuleSetting,
    method: 'post',
    data
  })
}
